var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessmentSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 79,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m41.64 45.344 10.366 25.4-11.662-2.43.041-.016-6.659 9.828-10.367-25.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M32.886 52.928 22.16 78.18l-6.52-9.92.041.017-11.695 2.265L14.712 45.29z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M55.993 27.848c0 1.438-1.765 2.722-1.983 4.1-.223 1.414 1.055 3.175.62 4.508-.443 1.356-2.521 2.033-3.164 3.286-.65 1.266.016 3.336-.818 4.476-.839 1.146-3.025 1.153-4.03 2.153s-1.012 3.174-2.164 4.008c-1.147.83-3.228.168-4.5.814-1.273.646-1.94 2.706-3.304 3.147-1.34.432-3.11-.838-4.532-.616-1.385.216-2.676 1.972-4.121 1.972s-2.737-1.755-4.122-1.972c-1.422-.222-3.192 1.049-4.532.616-1.363-.44-2.044-2.508-3.304-3.147-1.272-.646-3.353.016-4.5-.814-1.152-.834-1.159-3.009-2.164-4.008s-3.191-1.007-4.03-2.153c-.837-1.146-.169-3.21-.818-4.476-.643-1.252-2.72-1.93-3.163-3.286-.435-1.333.842-3.094.619-4.508C1.766 30.57 0 29.286 0 27.848s1.765-2.722 1.983-4.1c.223-1.414-1.054-3.175-.62-4.507.443-1.356 2.521-2.034 3.164-3.287.65-1.265-.016-3.335.819-4.476.838-1.146 3.024-1.153 4.03-2.152 1.004-1 1.011-3.175 2.163-4.009 1.147-.83 3.228-.168 4.5-.814 1.26-.64 1.941-2.706 3.304-3.147s3.11.839 4.532.617C25.26 1.756 26.551 0 27.997 0s2.736 1.756 4.121 1.973c1.422.222 3.192-1.05 4.532-.617 1.363.44 2.045 2.508 3.304 3.147 1.272.646 3.353-.016 4.5.814 1.152.834 1.159 3.009 2.164 4.009s3.192 1.006 4.03 2.152c.834 1.14.169 3.21.818 4.476.643 1.253 2.72 1.93 3.164 3.287.435 1.332-.843 3.093-.62 4.508.218 1.377 1.983 2.661 1.983 4.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.996 47.388c10.848 0 19.643-8.748 19.643-19.54s-8.795-19.54-19.644-19.54-19.643 8.749-19.643 19.54c0 10.792 8.794 19.54 19.644 19.54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M27.996 45.548c9.828 0 17.795-7.924 17.795-17.7s-7.967-17.7-17.795-17.7-17.795 7.924-17.795 17.7 7.967 17.7 17.795 17.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.335 22.007 27.421 35.23l-1.273 1.413-1.62-1.206-5.516-4.107 3.58-3.176 3.085 3.258 9.043-12.359z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 34.499,
    x2: 44.186,
    y1: 54.304,
    y2: 77.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57111f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#8a1c32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 22.78,
    x2: 14.048,
    y1: 51.675,
    y2: 72.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#691525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9b1f37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 8.87,
    x2: 48.185,
    y1: 12.832,
    y2: 44.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2bd27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1a051"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 15.831,
    x2: 40.837,
    y1: 18.297,
    y2: 38.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2bd27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28b27"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentSuccessIcon);
export default __webpack_public_path__ + "static/media/assessment-success-icon.fbac8722101ea7cdcb249a4a56547b56.svg";
export { ForwardRef as ReactComponent };